// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.api.web.handler.ZCalendarWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  ZCalendarWebApiHandler_disableTouringForListing,
  ZCalendarWebApiHandler_enableTouringForListing,
  ZCalendarWebApiHandler_getAvailability,
  ZCalendarWebApiHandler_getAvailability_Path,
  ZCalendarWebApiHandler_getAvailabilityAndToursForListing,
  ZCalendarWebApiHandler_getAvailabilityAndToursForListing_Path,
  ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene,
  ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_Path,
  ZCalendarWebApiHandler_getTourConfigAndAvailability,
  ZCalendarWebApiHandler_getTourConfigAndAvailability_Path,
  ZCalendarWebApiHandler_getTourForSatelliteConversationId,
  ZCalendarWebApiHandler_getTourForSatelliteConversationId_Path,
  ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing,
  ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_Path,
  ZCalendarWebApiHandler_getToursForListing,
  ZCalendarWebApiHandler_getToursForListing_Path,
  ZCalendarWebApiHandler_grantPrivateLinkRequest,
  ZCalendarWebApiHandler_performTourAction,
  ZCalendarWebApiHandler_removeAvailability,
  ZCalendarWebApiHandler_saveTourFeedback,
  ZCalendarWebApiHandler_setAvailabilitiesLite,
  ZCalendarWebApiHandler_setAvailability,
  ZCalendarWebApiHandler_storeListingCalendarTimeConfig,
  ZCalendarWebApiHandler_storeListingTimeZone,
  ZCalendarWebApiHandler_storeListingTourDuration,
  ZCalendarWebApiHandler_updateAvailability,
} from '@zg-rentals/ts-z-calendar-client';

import type {
  DisableTouringForListingWebApiRequestDto,
  EnableTouringForListingWebApiRequestDto,
  EnableTouringForListingWebApiResponseDto,
  GetAvailabilityAndToursForListingWebApiRequestDto,
  GetAvailabilityAndToursForListingWebApiResponseDto,
  GetAvailabilityWebApiRequestDto,
  GetAvailabilityWebApiResponseDto,
  GetAvailableTimesForRescheduleByIreneWebApiRequestDto,
  GetAvailableTimesForRescheduleByIreneWebApiResponseDto,
  GetTourConfigAndAvailabilityWebApiRequestDto,
  GetTourConfigAndAvailabilityWebApiResponseDto,
  GetTourForSatelliteConversationIdWebApiResponseDto,
  GetTouringTreatmentForZuidAndListingWebApiRequestDto,
  GetTouringTreatmentForZuidAndListingWebApiResponseDto,
  GetToursForListingWebApiRequestDto,
  GetToursForListingWebApiResponseDto,
  GrantPrivateLinkRequestWebApiRequestDto,
  ListingAlias,
  PerformTourActionWebApiRequestDto,
  PerformTourActionWebApiResponseDto,
  RemoveAvailabilityWebApiRequestDto,
  RemoveAvailabilityWebApiResponseDto,
  SaveTourFeedbackWebApiRequestDto,
  SetAvailabilitiesLiteWebApiRequestDto,
  SetAvailabilityWebApiRequestDto,
  SetAvailabilityWebApiResponseDto,
  StoreListingCalendarTimeConfigWebApiRequestDto,
  StoreListingTimeZoneWebApiRequestDto,
  StoreListingTourDurationWebApiRequestDto,
  UpdateAvailabilityWebApiRequestDto,
  UpdateAvailabilityWebApiResponseDto,
} from '@zg-rentals/ts-z-calendar-client';

interface GetTourForSatelliteConversationIdParams {
  conversationId: string;
  listingAlias: ListingAlias;
}

export interface ZCalendarWebApiHandler_disableTouringForListing_Args {
  postData: DisableTouringForListingWebApiRequestDto;
}

export type ZCalendarWebApiHandler_disableTouringForListing_Options = UseMutationOptions<
  void,
  unknown,
  ZCalendarWebApiHandler_disableTouringForListing_Args
>;

/**
 * disables all tours for a listing
 */
export const useZCalendarWebApiHandler_disableTouringForListing = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_disableTouringForListing_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_disableTouringForListing_Args) =>
      ZCalendarWebApiHandler_disableTouringForListing(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_enableTouringForListing_Args {
  postData: EnableTouringForListingWebApiRequestDto;
}

export type ZCalendarWebApiHandler_enableTouringForListing_Options = UseMutationOptions<
  EnableTouringForListingWebApiResponseDto,
  unknown,
  ZCalendarWebApiHandler_enableTouringForListing_Args
>;

/**
 * enable touring for a listing
 */
export const useZCalendarWebApiHandler_enableTouringForListing = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_enableTouringForListing_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_enableTouringForListing_Args) =>
      ZCalendarWebApiHandler_enableTouringForListing(args.postData, httpClient),
  });
};

export type ZCalendarWebApiHandler_getAvailability_Options = UseQueryOptions<
  GetAvailabilityWebApiResponseDto,
  unknown,
  GetAvailabilityWebApiResponseDto,
  Array<string | GetAvailabilityWebApiRequestDto>
>;

const ZCalendarWebApiHandler_getAvailability_GetKey = (postData: GetAvailabilityWebApiRequestDto) => [
  ZCalendarWebApiHandler_getAvailability_Path,
  postData,
];

/**
 * get tour availability for a listing for a certain time period
 */
export const useZCalendarWebApiHandler_getAvailability = (
  postData: GetAvailabilityWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ZCalendarWebApiHandler_getAvailability_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ZCalendarWebApiHandler_getAvailability_GetKey(postData),
    queryFn: () => ZCalendarWebApiHandler_getAvailability(postData, httpClient),
  });
};
useZCalendarWebApiHandler_getAvailability.getKey = ZCalendarWebApiHandler_getAvailability_GetKey;

export type ZCalendarWebApiHandler_getAvailabilityAndToursForListing_Options = UseQueryOptions<
  GetAvailabilityAndToursForListingWebApiResponseDto,
  unknown,
  GetAvailabilityAndToursForListingWebApiResponseDto,
  Array<string | GetAvailabilityAndToursForListingWebApiRequestDto>
>;

const ZCalendarWebApiHandler_getAvailabilityAndToursForListing_GetKey = (
  postData: GetAvailabilityAndToursForListingWebApiRequestDto,
) => [ZCalendarWebApiHandler_getAvailabilityAndToursForListing_Path, postData];

/**
 * get availability and tours for full calendar
 */
export const useZCalendarWebApiHandler_getAvailabilityAndToursForListing = (
  postData: GetAvailabilityAndToursForListingWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ZCalendarWebApiHandler_getAvailabilityAndToursForListing_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ZCalendarWebApiHandler_getAvailabilityAndToursForListing_GetKey(postData),
    queryFn: () => ZCalendarWebApiHandler_getAvailabilityAndToursForListing(postData, httpClient),
  });
};
useZCalendarWebApiHandler_getAvailabilityAndToursForListing.getKey =
  ZCalendarWebApiHandler_getAvailabilityAndToursForListing_GetKey;

export type ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_Options = UseQueryOptions<
  GetAvailableTimesForRescheduleByIreneWebApiResponseDto,
  unknown,
  GetAvailableTimesForRescheduleByIreneWebApiResponseDto,
  Array<string | GetAvailableTimesForRescheduleByIreneWebApiRequestDto>
>;

const ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_GetKey = (
  postData: GetAvailableTimesForRescheduleByIreneWebApiRequestDto,
) => [ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_Path, postData];

/**
 * get available times for reschedule by irene
 */
export const useZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene = (
  postData: GetAvailableTimesForRescheduleByIreneWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_GetKey(postData),
    queryFn: () => ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene(postData, httpClient),
  });
};
useZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene.getKey =
  ZCalendarWebApiHandler_getAvailableTimesForRescheduleByIrene_GetKey;

export type ZCalendarWebApiHandler_getTourConfigAndAvailability_Options = UseQueryOptions<
  GetTourConfigAndAvailabilityWebApiResponseDto,
  unknown,
  GetTourConfigAndAvailabilityWebApiResponseDto,
  Array<string | GetTourConfigAndAvailabilityWebApiRequestDto>
>;

const ZCalendarWebApiHandler_getTourConfigAndAvailability_GetKey = (
  postData: GetTourConfigAndAvailabilityWebApiRequestDto,
) => [ZCalendarWebApiHandler_getTourConfigAndAvailability_Path, postData];

/**
 * get tour config and availability for a listing for a certain time period
 */
export const useZCalendarWebApiHandler_getTourConfigAndAvailability = (
  postData: GetTourConfigAndAvailabilityWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ZCalendarWebApiHandler_getTourConfigAndAvailability_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ZCalendarWebApiHandler_getTourConfigAndAvailability_GetKey(postData),
    queryFn: () => ZCalendarWebApiHandler_getTourConfigAndAvailability(postData, httpClient),
  });
};
useZCalendarWebApiHandler_getTourConfigAndAvailability.getKey =
  ZCalendarWebApiHandler_getTourConfigAndAvailability_GetKey;

export type ZCalendarWebApiHandler_getTourForSatelliteConversationId_Options = UseQueryOptions<
  GetTourForSatelliteConversationIdWebApiResponseDto,
  unknown,
  GetTourForSatelliteConversationIdWebApiResponseDto,
  Array<string | GetTourForSatelliteConversationIdParams>
>;

const ZCalendarWebApiHandler_getTourForSatelliteConversationId_GetKey = (
  getParams: GetTourForSatelliteConversationIdParams,
) => [ZCalendarWebApiHandler_getTourForSatelliteConversationId_Path, getParams];

/**
 * get tour for satellite conversation id
 */
export const useZCalendarWebApiHandler_getTourForSatelliteConversationId = (
  getParams: GetTourForSatelliteConversationIdParams,
  {
    httpClient,
    ...options
  }: Omit<ZCalendarWebApiHandler_getTourForSatelliteConversationId_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ZCalendarWebApiHandler_getTourForSatelliteConversationId_GetKey(getParams),
    queryFn: () => ZCalendarWebApiHandler_getTourForSatelliteConversationId(getParams, httpClient),
  });
};
useZCalendarWebApiHandler_getTourForSatelliteConversationId.getKey =
  ZCalendarWebApiHandler_getTourForSatelliteConversationId_GetKey;

export type ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_Options = UseQueryOptions<
  GetTouringTreatmentForZuidAndListingWebApiResponseDto,
  unknown,
  GetTouringTreatmentForZuidAndListingWebApiResponseDto,
  Array<string | GetTouringTreatmentForZuidAndListingWebApiRequestDto>
>;

const ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_GetKey = (
  postData: GetTouringTreatmentForZuidAndListingWebApiRequestDto,
) => [ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_Path, postData];

/**
 * get touring treatment status for irene zuid
 */
export const useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing = (
  postData: GetTouringTreatmentForZuidAndListingWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_GetKey(postData),
    queryFn: () => ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing(postData, httpClient),
  });
};
useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing.getKey =
  ZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing_GetKey;

export type ZCalendarWebApiHandler_getToursForListing_Options = UseQueryOptions<
  GetToursForListingWebApiResponseDto,
  unknown,
  GetToursForListingWebApiResponseDto,
  Array<string | GetToursForListingWebApiRequestDto>
>;

const ZCalendarWebApiHandler_getToursForListing_GetKey = (postData: GetToursForListingWebApiRequestDto) => [
  ZCalendarWebApiHandler_getToursForListing_Path,
  postData,
];

/**
 * get tours for listing with optional bookedBy and tour status filter
 */
export const useZCalendarWebApiHandler_getToursForListing = (
  postData: GetToursForListingWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ZCalendarWebApiHandler_getToursForListing_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ZCalendarWebApiHandler_getToursForListing_GetKey(postData),
    queryFn: () => ZCalendarWebApiHandler_getToursForListing(postData, httpClient),
  });
};
useZCalendarWebApiHandler_getToursForListing.getKey = ZCalendarWebApiHandler_getToursForListing_GetKey;

export interface ZCalendarWebApiHandler_grantPrivateLinkRequest_Args {
  postData: GrantPrivateLinkRequestWebApiRequestDto;
}

export type ZCalendarWebApiHandler_grantPrivateLinkRequest_Options = UseMutationOptions<
  void,
  unknown,
  ZCalendarWebApiHandler_grantPrivateLinkRequest_Args
>;

/**
 * grant private calendar access to rachel user
 */
export const useZCalendarWebApiHandler_grantPrivateLinkRequest = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_grantPrivateLinkRequest_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_grantPrivateLinkRequest_Args) =>
      ZCalendarWebApiHandler_grantPrivateLinkRequest(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_performTourAction_Args {
  postData: PerformTourActionWebApiRequestDto;
}

export type ZCalendarWebApiHandler_performTourAction_Options = UseMutationOptions<
  PerformTourActionWebApiResponseDto,
  unknown,
  ZCalendarWebApiHandler_performTourAction_Args
>;

/**
 * perform user-initiated tour actions from UX
 */
export const useZCalendarWebApiHandler_performTourAction = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_performTourAction_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_performTourAction_Args) =>
      ZCalendarWebApiHandler_performTourAction(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_removeAvailability_Args {
  postData: RemoveAvailabilityWebApiRequestDto;
}

export type ZCalendarWebApiHandler_removeAvailability_Options = UseMutationOptions<
  RemoveAvailabilityWebApiResponseDto,
  unknown,
  ZCalendarWebApiHandler_removeAvailability_Args
>;

/**
 * remove tour availability
 */
export const useZCalendarWebApiHandler_removeAvailability = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_removeAvailability_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_removeAvailability_Args) =>
      ZCalendarWebApiHandler_removeAvailability(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_saveTourFeedback_Args {
  postData: SaveTourFeedbackWebApiRequestDto;
}

export type ZCalendarWebApiHandler_saveTourFeedback_Options = UseMutationOptions<
  void,
  unknown,
  ZCalendarWebApiHandler_saveTourFeedback_Args
>;

/**
 * save landlord response for tour feedback
 */
export const useZCalendarWebApiHandler_saveTourFeedback = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_saveTourFeedback_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_saveTourFeedback_Args) =>
      ZCalendarWebApiHandler_saveTourFeedback(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_setAvailabilitiesLite_Args {
  postData: SetAvailabilitiesLiteWebApiRequestDto;
}

export type ZCalendarWebApiHandler_setAvailabilitiesLite_Options = UseMutationOptions<
  void,
  unknown,
  ZCalendarWebApiHandler_setAvailabilitiesLite_Args
>;

/**
 * bulk set tour availabilities for posting path
 */
export const useZCalendarWebApiHandler_setAvailabilitiesLite = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_setAvailabilitiesLite_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_setAvailabilitiesLite_Args) =>
      ZCalendarWebApiHandler_setAvailabilitiesLite(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_setAvailability_Args {
  postData: SetAvailabilityWebApiRequestDto;
}

export type ZCalendarWebApiHandler_setAvailability_Options = UseMutationOptions<
  SetAvailabilityWebApiResponseDto,
  unknown,
  ZCalendarWebApiHandler_setAvailability_Args
>;

/**
 * set tour availability for a user and listing
 */
export const useZCalendarWebApiHandler_setAvailability = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_setAvailability_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_setAvailability_Args) =>
      ZCalendarWebApiHandler_setAvailability(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_storeListingCalendarTimeConfig_Args {
  postData: StoreListingCalendarTimeConfigWebApiRequestDto;
}

export type ZCalendarWebApiHandler_storeListingCalendarTimeConfig_Options = UseMutationOptions<
  void,
  unknown,
  ZCalendarWebApiHandler_storeListingCalendarTimeConfig_Args
>;

/**
 * store custom calendar start and end times for a listing
 */
export const useZCalendarWebApiHandler_storeListingCalendarTimeConfig = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_storeListingCalendarTimeConfig_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_storeListingCalendarTimeConfig_Args) =>
      ZCalendarWebApiHandler_storeListingCalendarTimeConfig(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_storeListingTimeZone_Args {
  postData: StoreListingTimeZoneWebApiRequestDto;
}

export type ZCalendarWebApiHandler_storeListingTimeZone_Options = UseMutationOptions<
  void,
  unknown,
  ZCalendarWebApiHandler_storeListingTimeZone_Args
>;

/**
 * store time zone for a listing
 */
export const useZCalendarWebApiHandler_storeListingTimeZone = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_storeListingTimeZone_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_storeListingTimeZone_Args) =>
      ZCalendarWebApiHandler_storeListingTimeZone(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_storeListingTourDuration_Args {
  postData: StoreListingTourDurationWebApiRequestDto;
}

export type ZCalendarWebApiHandler_storeListingTourDuration_Options = UseMutationOptions<
  void,
  unknown,
  ZCalendarWebApiHandler_storeListingTourDuration_Args
>;

/**
 * store tour duration for a listing
 */
export const useZCalendarWebApiHandler_storeListingTourDuration = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_storeListingTourDuration_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_storeListingTourDuration_Args) =>
      ZCalendarWebApiHandler_storeListingTourDuration(args.postData, httpClient),
  });
};

export interface ZCalendarWebApiHandler_updateAvailability_Args {
  postData: UpdateAvailabilityWebApiRequestDto;
}

export type ZCalendarWebApiHandler_updateAvailability_Options = UseMutationOptions<
  UpdateAvailabilityWebApiResponseDto,
  unknown,
  ZCalendarWebApiHandler_updateAvailability_Args
>;

/**
 * update tour availability
 */
export const useZCalendarWebApiHandler_updateAvailability = ({
  httpClient,
  ...options
}: Omit<ZCalendarWebApiHandler_updateAvailability_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ZCalendarWebApiHandler_updateAvailability_Args) =>
      ZCalendarWebApiHandler_updateAvailability(args.postData, httpClient),
  });
};
